import {
  BoldOutlined,
  FontColorsOutlined,
  LineOutlined,
  QuestionOutlined,
} from '@ant-design/icons';

export const API_DEV_URL = 'https://performance-management-api.buddieshr.com';
export const API_URL = 'https://performance-management-api.buddieshr.com';

// Migration: SimplePerf now lives inside the BuddiesHR dashboard webapp.
// Logged-in users are handed off to the new app, carrying their existing session.
export const MIGRATION_REDIRECT_ENABLED = true;
export const NEW_APP_URL = 'https://dashboard.buddieshr.com';
export const NEW_APP_NAME = 'simpleperf';

export const LOCAL_STORAGE = {
  REF: 'SIMPLEPERF_ref',
  HAS_SEEN_PRICING: 'HAS_SEEN_PRICING',
  GET_STARTED_COMPLETED: 'get_started_form_completed',
  LANDING_QUERY_STRING: 'landing_query_string',
};

export const CRISP_WEBSITE_ID_PERS = '14703f10-388b-4ace-8e47-9122ebc57196';

export const ROLLBAR_ACCESS_TOKEN = '8cebf4d3f6014b2cbb601167582c5361';

// Below expectations
// Meet expectations
// Exceeds expectations
// Greatly exceeds expectations
//Truly outstanding
export const QUESTIONS_TYPES = {
  OPEN_ENDED: { id: 'OPEN_ENDED', label: 'Open ended' },
  MULTIPLE_CHOICE: { id: 'MULTIPLE_CHOICE', label: 'Multiple choice' },
  RATING: { id: 'RATING', label: 'Rating' },
};
export const BLOCK_TYPES = {
  QUESTION: { id: 'QUESTION', label: 'Question', icon: <QuestionOutlined /> },
  HEADER: { id: 'HEADER', label: 'Title', icon: <BoldOutlined /> },
  SECTION: {
    id: 'SECTION',
    label: 'Text section',
    icon: <FontColorsOutlined />,
  },
  DIVIDER: { id: 'DIVIDER', label: 'Divider', icon: <LineOutlined /> },
};
export const STEPS = {
  MODULES: 'MODULES',
  PARTICIPANTS: 'PARTICIPANTS',
  SETTINGS: 'SETTINGS',
};

export const CLOUDINARY = {
  CLOUD_NAME: 'dfvooywtv',
  UPLOAD_PRESETS: 'ml_default',
};

export const MODULES_ITEMS = {
  SELF: {
    type: 'SELF',
    label: 'Self Review',
    labelShort: 'Self Review',
    selected: true,
    blocks: [
      {
        _id: 'GENERATED_1',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 1,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What 2-3 strengths did you exhibit in the performance period that most helped you be successful? Give examples of how these strengths had a positive impact on the team, department or company.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_2',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 2,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What have been your top accomplishments in the performance period? What impact did each have on the team, department or company?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_3',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 3,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What challenges, if any, did you encounter during this performance period? How did they impact your performance?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_4',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 4,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What goals/objectives do you think you should focus on over the next performance period?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_5',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 5,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'Which of our values do you feel like you most embody in how you work? Give concrete examples.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
    ],
  },
  UPWARD: {
    type: 'UPWARD',
    label: 'Upward review (employee reviews its manager)',
    labelShort: 'Upward review',
    blocks: [
      {
        _id: 'GENERATED_11',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 1,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What are 2-3 things that this person can start or stop doing in order to be more effective, or help make you more successful?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_12',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 2,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What are 1-3 things that this person should continue doing?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_13',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 3,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'Which of our values do you see this person demonstrating most? Give concrete examples.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
    ],
    selected: false,
  },
  PEER: {
    type: 'PEER',
    label: 'Peer review',
    labelShort: 'Peer review',
    blocks: [
      {
        _id: 'GENERATED_21',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 1,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What 2-3 strengths did you see this person exhibit in the performance period? Give examples of when you saw these strengths demonstrated.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_22',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 2,
        params: {
          type: QUESTIONS_TYPES.MULTIPLE_CHOICE.id,
          text: 'What impact did this person have on your ability to achieve your goals during the performance periodi?',
          isRequired: true,
          choices: [
            'They prevented me from achieving my goals',
            'They had little impact on my ability to achieve my goals ',
            'They sometimes helped me achieve my goals',
            'They consistently helped me achieve my goals',
            'They went above and beyond in helping me achieve my goals',
          ],
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_23',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 3,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What do you think is the most valuable contribution this person has made to the company in the performance period?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_24',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 4,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What are 2-3 things this person could have done differently in the performance period to be more effective in working with you?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
    ],
    selected: false,
  },
  DOWNWARD: {
    type: 'DOWNWARD',
    label: 'Manager review (downward review)',
    labelShort: 'Manager review',
    blocks: [
      {
        _id: 'GENERATED_31',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 1,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What 2-3 strengths did you see this person exhibit in this performance period? Give examples of how these strengths had a positive impact on the team, department or company.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_32',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 2,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'Describe the expectations that you had for this person over the performance period. To what extent did they meet these expectations?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_33',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 3,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'Which of our values do you see this person demonstrating most? Give concrete examples.',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_34',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 4,
        params: {
          type: QUESTIONS_TYPES.OPEN_ENDED.id,
          text: 'What could this person do differently to be more impactful in the future?',
          isRequired: true,
          isCommentOptional: true,
          hasComment: false,
        },
      },
      {
        _id: 'GENERATED_35',
        type: BLOCK_TYPES.QUESTION.id,
        questionNumber: 5,
        params: {
          type: QUESTIONS_TYPES.MULTIPLE_CHOICE.id,
          text: ' Do you recommend this individual for promotion? If yes, please provide justification for your recommendation. If no, in what key areas can the employee grow to be ready for promotion?',
          isRequired: true,
          choices: ['Yes', 'No'],
          isCommentOptional: true,
          hasComment: true,
        },
      },
    ],
    selected: false,
  },
};

export const CURRENT_REVIEW_DISPLAY = {
  TODO: 'todo',
  RECEIVED: 'received',
};
export const CYCLE_STATUS = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  LIVE: 'LIVE',
};

export const REMINDERS_CHANNEL = {
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
};
export const REMINDERS_TRIGGER = {
  HALF: {
    type: 'HALF',
    label: 'At Half time',
  },
  THREE_QUARTERS: {
    type: 'THREE_QUARTERS',
    label: '3/4 of the cycle',
  },
  ONE_DAY_BEFORE: {
    type: 'ONE_DAY_BEFORE',
    label: 'One day before',
  },
};

export const REVIEW_STATUS = {
  TO_DO: 'TO_DO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  READY: 'READY',
};

export const ROLE = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};

export const REVIEW_VISIBILITY = {
  IMMEDIATE: 'IMMEDIATE',
  MANAGER_RELEASE: 'MANAGER_RELEASE',
};

export const AI_USAGE_REACTION = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
};

export const LLM_REFERRERS = [
  'chat.openai.com',
  'claude.ai',
  'perplexity.ai',
  'copilot.microsoft.com',
  'gemini.google.com'
]
